<template>
  <svg :width="size" :height="size" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <!-- Devil silhouette with horns -->
    <circle cx="16" cy="13" r="6" :fill="color" />
    <!-- Devil horns -->
    <path d="M11 9L8 3" :stroke="color" stroke-width="2.5" stroke-linecap="round" />
    <path d="M21 9L24 3" :stroke="color" stroke-width="2.5" stroke-linecap="round" />
    <!-- Body/shoulders -->
    <path d="M6 28c0-5.5 4.5-9 10-9s10 3.5 10 9" :fill="color" opacity="0.8" />
  </svg>
</template>
<script setup lang="ts">
withDefaults(defineProps<{ size?: number; color?: string }>(), {
  size: 28,
  color: '#CC0000',
});
</script>
